/**
 * Update wipe count when variant changes
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initWipeCountUpdater();
  });

  function initWipeCountUpdater() {
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        const variant = event.data.variant;
        if (variant) {
          updateWipeCount(variant);
        }
      });
    }
  }

  function updateWipeCount(variant) {
    const wipeCountElement = document.querySelector('[data-wipe-count-value]');
    if (!wipeCountElement) return;

    let wipeCount = '';
    const title = variant.title || '';
    
    if (title.includes('1 Pack')) {
      wipeCount = '50 Wipes';
    } else if (title.includes('3 Pack')) {
      wipeCount = '150 Wipes';
    } else if (title.includes('6 Pack')) {
      wipeCount = '300 Wipes';
    }

    if (wipeCount) {
      wipeCountElement.style.opacity = '0.5';
      wipeCountElement.style.transition = 'opacity 0.15s ease';
      
      setTimeout(function() {
        wipeCountElement.textContent = wipeCount;
        wipeCountElement.style.opacity = '1';
      }, 150);
    }
  }
})();